import { ChangeDetectorRef, Component } from "@angular/core";
import { LicenseService } from "../../services/LicenseService";
import { AppLoaderService } from "../../../services/app-loader/app-loader.service";
import { apply } from "core-js/fn/reflect";
import { MdDialog, MdDialogRef } from "@angular/material";
import { AddEditFaqComponent } from "../faq/add-edit-faq/add-edit-faq.component";
import { AddEditLZ30DeviceComponent } from "./add-lz30-device/add-lz30-device.component";
import { AddLz30DeviceLicenseRequest } from "./add-lz30-device-license-request/add-lz30-device-license-request.component";
import { ViewLZ30PurchaseLicenseHistory } from "./view-lz30-purchase-history/view-lz30-purchase-history.component";
import { ActivatedRoute, Router } from "@angular/router";
import { AdalService } from "../../shared/adal.service";
import { ExportToCSVService } from "../../services/ExportToCSVService";
import Swal from "sweetalert2";
import { PagerService } from "../../services/PagerService";
import { UserService } from "../../services/UserService";
import { ExtendLZ30TrialPeriod } from "./extend-LZ30-trial-period/extend-LZ30-trial-period.component";
import { ViewLZ30DeviceHistory } from "./view-lz30-device-history/view-lz30-device-history.component";
import { Lz30DeviceInfoFilterPipe } from "./pipes/lz30DeviceInfoFilterPipe";
import { LZ30PurchaseLicenseFilterPipe } from "./pipes/lz30PurchaseLicenseFilterPipe";

@Component({
    selector:'license-lz30',
    template:require('./lz30.component.html'),
    styles:[require('./lz30.component.css')],
})
export class LicenseModuleLz30Component{
    title="LZ-30";
    originalUserDeviceDisplayDetail=[];
    userDeviceDisplayDetail=[];
    filteredUserDeviceDisplayDetail;
    searchName='';
    searchEmailId='';
    searchMobileNo='';
    searchSerialNoInDeviceTab='';
    searchSerialNoInPurchaseTab=''
    searchBillToName='';
    searchShipToName='';
    filterName='';
    filterEmailId='';
    filterMobileNo='';
    filterSerialNoInDeviceTab='';
    filterSerialNoInPurchaseTab=''
    filterBillTo='';
    filterShipTo=''
    lz30PurchaseLicenseDetailList=[];
    originalLz30PurchaseLicenseDetailList=[];
    filteredLz30PurchaseLicenseDetailList=[];
    UserDeviceDetail=[]
    expandedRow:number|null=null;
    error='';
    serialNoList=[];
    BillToList=[];
    ShipToList=[];
    isLoading=false;
    demoPager:any={};
    demoPageItems;
    purchasePager:any={};
    purchasePageItems;
    IsAddEdit;
    IsDelete;
    ProductId;
    errorMessageDemoPage="";
    errorMessagePurchasePage="";
    purchaseCurrentSortOrder='';
    purchaseCurrentSortColumn='';
    deviceCurrentSortOrder='';
    deviceCurrentSortColumn='';
    constructor(
        private licenseService:LicenseService, 
        private dialog:MdDialog,
        private appLoader:AppLoaderService,
        private adalService:AdalService,
        private router:Router,
        private exportService:ExportToCSVService,
        private pagerService:PagerService,
        private route:ActivatedRoute,
        private userService:UserService,
        private demoFilterPipe:Lz30DeviceInfoFilterPipe,
        private purchaseFilterPipe:LZ30PurchaseLicenseFilterPipe,
    ){
            // this.appLoader.open()
            if (!this.adalService.getCachedToken()) {
                setTimeout(() => {
                    this.router.navigate(["login"]);
                }, 100);
            }
            
                appLoader.close();
                this.route.params.subscribe((params)=>{
                    this.ProductId=params['productId']
                })
                this.getUserRights();
                this.getUserDeviceDisplayDetail();
                this.getLz30PurchaseLicenseDetail();
    }
    getUserRights(){
        let UserId=Number(localStorage.getItem('userid'))
        this.userService.getUserLicenseRightById(UserId,this.ProductId).subscribe((data)=>{
            if(!data.IsError && data.DataObject!=null){
                this.IsAddEdit=data.DataObject.IsAddEdit;
                this.IsDelete=data.DataObject.IsDelete;
            }
        })
    }
    getUserDeviceDisplayDetail(){
        this.licenseService.getLz30UserDeviceDisplayDetail().subscribe((data)=>{
            if(!data.IsError && data.DataObject!=null){
                this.originalUserDeviceDisplayDetail=data.DataObject;
                this.userDeviceDisplayDetail=[...this.originalUserDeviceDisplayDetail];
                this.setPageForDemo(1);
                // this.createSerialNoList();
            }
        })
    }
    getLz30PurchaseLicenseDetail(){
        this.licenseService.getLz30PurchaseLicenseDisplayDetail().subscribe((data)=>{
            if(!data.IsError && data.DataObject){
                this.originalLz30PurchaseLicenseDetailList=data.DataObject;
                this.lz30PurchaseLicenseDetailList=[...this.originalLz30PurchaseLicenseDetailList];
                this.buildSearchArray();
                this.setPageForPurchase(1);
            }
            else{
                this.error=data.Error;
            }
            this.appLoader.close();
        })
    }
    // createSerialNoList(){
    //     this.userDeviceDisplayDetail.forEach((device)=>{
    //         this.serialNoList.push(device.DeviceSerialNo)
    //     })
    // }
    expandRow(index,row){
        this.isLoading=true;
        this.expandedRow = this.expandedRow === index ? null : index;
        if(this.expandedRow!=null){
            this.UserDeviceDetail=[];
            this.licenseService.getLZ30LicenseDetail(row.LZ30UserDeviceId).subscribe((data)=>{
                if(!data.IsError && data.DataObject!=null){
                    this.UserDeviceDetail=data.DataObject
                }
                else{
    
                }
                this.isLoading=false;
            })
        }
    }
    buildSearchArray(){
        const BillToArray=this.lz30PurchaseLicenseDetailList.map(item=>item.BillToName)
        const ShipToArray=this.lz30PurchaseLicenseDetailList.map(item=>item.ShipToName)
        this.BillToList=Array.from(new Set(BillToArray)).sort();
        this.ShipToList=Array.from(new Set(ShipToArray)).sort();
    }
    addDevice(){
        let addLz30DialogRef:MdDialogRef<AddEditLZ30DeviceComponent>=this.dialog.open(AddEditLZ30DeviceComponent,{
            width:"40%",
            height:"40%",
            disableClose:true,
            data:{
                userDeviceDisplayData:this.originalUserDeviceDisplayDetail,
                SelectedDeviceDetail:null
            }
        })
        addLz30DialogRef.afterClosed().subscribe((result)=>{
            this.originalUserDeviceDisplayDetail=result;
            this.userDeviceDisplayDetail=[...this.originalUserDeviceDisplayDetail];
            this.setPageForDemo(1);
        })
    }
    extendLZ30TrialPeriod(row){
        let extendLZ30TrialPeriodDialogRef:MdDialogRef<ExtendLZ30TrialPeriod>=this.dialog.open(ExtendLZ30TrialPeriod,{
            width:'40%',
            height:'40%',
            disableClose:true,
            data:{
                userDeviceDisplayData:this.originalUserDeviceDisplayDetail,
                SelectedDeviceDetail:row
            }
        })
        extendLZ30TrialPeriodDialogRef.afterClosed().subscribe((result)=>{
            this.originalUserDeviceDisplayDetail=result;
            this.userDeviceDisplayDetail=[...this.originalUserDeviceDisplayDetail];
            this.setPageForDemo(this.demoPager.currentPage);
        })
    }
    viewDeviceHistory(row){
        let videDeviceHistoryDialogRef:MdDialogRef<ViewLZ30DeviceHistory>=this.dialog.open(ViewLZ30DeviceHistory,{
            width:'60%',
            height:'80%',
            disableClose:true,
            data:{
                userDeviceDisplayData:this.originalUserDeviceDisplayDetail,
                SelectedDeviceDetail:row
            }
        })
    }
    addNewDeviceLicenseRequest(){
        let addNewDeviceLicenseRequestDialogRef:MdDialogRef<AddLz30DeviceLicenseRequest>=this.dialog.open(AddLz30DeviceLicenseRequest,{
            width:'60%',
            height:'80%',
            disableClose:true,
            data:{
                userDeviceDisplayData:this.originalUserDeviceDisplayDetail,
                purchaseLicenseDisplayData:this.originalLz30PurchaseLicenseDetailList,
                SelectedCustomerDetail:null
            }
        })
        addNewDeviceLicenseRequestDialogRef.afterClosed().subscribe((result)=>{
            this.originalLz30PurchaseLicenseDetailList=result;
                this.lz30PurchaseLicenseDetailList=[...this.originalLz30PurchaseLicenseDetailList];
            this.expandedRow=null;
            this.setPageForPurchase(1);
        })
    }
    addMoreLicenseRequest(row){
        let addMoreDeviceLicenseRequestDialogRef:MdDialogRef<AddLz30DeviceLicenseRequest>=this.dialog.open(AddLz30DeviceLicenseRequest,{
            width:'60%',
            height:'80%',
            disableClose:true,
            data:{
                userDeviceDisplayData:this.originalUserDeviceDisplayDetail,
                purchaseLicenseDisplayData:this.originalLz30PurchaseLicenseDetailList,
                SelectedCustomerDetail:row
            }
        })
        addMoreDeviceLicenseRequestDialogRef.afterClosed().subscribe((result)=>{
            this.originalLz30PurchaseLicenseDetailList=result;
            this.lz30PurchaseLicenseDetailList=[...this.originalLz30PurchaseLicenseDetailList];
            this.expandedRow=null;
            this.setPageForPurchase(this.purchasePager.currentPage);
        })
    }
    viewLz30PurchaseLicenseHistory(row){
        let viewLz30PurchaseLicenseHistory:MdDialogRef<ViewLZ30PurchaseLicenseHistory>=this.dialog.open(ViewLZ30PurchaseLicenseHistory,{
            width:'60%',
            height:'80%',
            disableClose:true,
            data:{
                SelectedCustomerDetail:row,
                userDeviceDisplayData:this.originalUserDeviceDisplayDetail,
                purchaseLicenseDisplayData:this.originalLz30PurchaseLicenseDetailList,
            }
        })
        viewLz30PurchaseLicenseHistory.afterClosed().subscribe((result)=>{
           this.originalLz30PurchaseLicenseDetailList=result;
           this.lz30PurchaseLicenseDetailList=[...this.originalLz30PurchaseLicenseDetailList];
        })
    }
    setPageForDemo(page: number) {
        this.userDeviceDisplayDetail=[...this.originalUserDeviceDisplayDetail];
        this.deviceApplySort();
        this.filteredUserDeviceDisplayDetail=this.demoFilterPipe.transform(this.userDeviceDisplayDetail,this.filterName,this.filterEmailId,this.filterMobileNo,this.filterSerialNoInDeviceTab)
        this.demoPager = this.pagerService.getPager(this.filteredUserDeviceDisplayDetail.length, page);
        this.demoPageItems = this.filteredUserDeviceDisplayDetail.slice(this.demoPager.startIndex, this.demoPager.endIndex + 1);
        this.errorMessageDemoPage=(this.demoPageItems.length==0)?"No records found.":"";
    }
    setPageForPurchase(page: number) {
        this.lz30PurchaseLicenseDetailList=[...this.originalLz30PurchaseLicenseDetailList];
        this.purchaseApplySort();
        this.filteredLz30PurchaseLicenseDetailList=this.purchaseFilterPipe.transform(this.lz30PurchaseLicenseDetailList,this.filterBillTo,this.filterShipTo,this.filterSerialNoInPurchaseTab)
        this.purchasePager = this.pagerService.getPager(this.filteredLz30PurchaseLicenseDetailList.length, page);
        this.purchasePageItems = this.filteredLz30PurchaseLicenseDetailList.slice(this.purchasePager.startIndex, this.purchasePager.endIndex + 1);
        this.errorMessagePurchasePage=(this.purchasePageItems.length==0)?"No records found.":"";
    }
    onEdit(row){
        let editLz30Dialog:MdDialogRef<AddEditLZ30DeviceComponent>=this.dialog.open(AddEditLZ30DeviceComponent,{
            width:"40%",
            height:"40%",
            data:{
                userDeviceDisplayData:this.originalUserDeviceDisplayDetail,
                SelectedCustomerDetail:row
            }
        })
        editLz30Dialog.afterClosed().subscribe((result)=>{
            this.originalUserDeviceDisplayDetail=result;
            this.userDeviceDisplayDetail=[...this.originalUserDeviceDisplayDetail];
            console.log(this.demoPager.currentPage)
            this.setPageForDemo(this.demoPager.currentPage);
        })
    }
    exportDeviceInfo(){
        let jsonData:Array<any>=[];
            if(this.userDeviceDisplayDetail){
                this.userDeviceDisplayDetail.forEach(element => {
                    jsonData.push({
                        Name:element.Name,
                        EmailId:element.EmailId,
                        MobileNo:element.Mobile,
                        MACAddress:element.MACAddress,
                        SerialNo:element.DeviceSerialNo,
                        StartDate:element.StartDate,
                        EndDate:element.EndDate,
                        LicenseType:element.LicenseType,
                        FeedBackDate:element.FeedbackDate
                    })
                });
                this.exportService.exportToCsv(jsonData,'LZ30DemoLicenseInfo')
            }
            else{
                Swal.fire({
                    title:'No data',
                    text:'There is no data available to export to CSV file.',
                    showCloseButton:true,
                    showConfirmButton:true,
                    confirmButtonColor:'#FFCA28'
                })
            }
    }
    exportDevicePurchaseInfo(){
        let jsonData:Array<any>=[];
            if(this.lz30PurchaseLicenseDetailList){
                this.lz30PurchaseLicenseDetailList.forEach(element => {
                    jsonData.push({
                        BillToName:element.BillToName,
                        BillToAddress1:element.BillToAddress1,
                        BillToAddress2:element.BillToAddress2,
                        BillToCity:element.BillToCity,
                        BillToState:element.BillToState,
                        BillToZipcode:element.BillToZipcode,
                        BillToCountryCode:element.BillToCountryCode,
                        ShipToName:element.ShipToName,
                        ShipToAddress1:element.ShipToAddress1,
                        ShipToAddress2:element.ShipToAddress2,
                        ShipToCity:element.ShipToCity,
                        ShipToState:element.ShipToState,
                        ShipToZipcode:element.ShipToZipcode,
                        ShipToCountryCode:element.ShipToCountryCode,
                        TotalDevicePurchased:element.TotalNoOfDevicePurchased
                    })
                });
                this.exportService.exportToCsv(jsonData,'LZ30PurchaseLicenseInfo')
            }
            else{
                Swal.fire({
                    title:'No data',
                    text:'There is no data available to export to CSV file.',
                    showCloseButton:true,
                    showConfirmButton:true,
                    confirmButtonColor:'#FFCA28'
                })
            }
    }
    searchDeviceInfo(){
        this.filterName=this.searchName;
        this.filterEmailId=this.searchEmailId;
        this.filterMobileNo=this.searchMobileNo;
        this.filterSerialNoInDeviceTab=this.searchSerialNoInDeviceTab;
        this.setPageForDemo(1);
    }
    searchPurchaseInfo(){
        this.filterSerialNoInPurchaseTab=this.searchSerialNoInPurchaseTab;
        this.filterBillTo=this.searchBillToName;
        this.filterShipTo=this.searchShipToName;
        this.expandedRow=null;
        this.setPageForPurchase(1);
    }
    clearDeviceInfo(){
        this.searchName=this.filterName='';
        this.searchEmailId=this.filterEmailId='';
        this.searchMobileNo=this.filterMobileNo='';
        this.filterSerialNoInDeviceTab=this.searchSerialNoInDeviceTab='';
        this.setPageForDemo(1);
    }
    clearPurchaseInfo(){
        this.filterSerialNoInPurchaseTab=this.searchSerialNoInPurchaseTab='';
        this.filterBillTo=this.searchBillToName='';
        this.filterShipTo=this.searchShipToName='';
        this.expandedRow=null;
        this.setPageForPurchase(1);
    }
    onPurchaseSortChange(event){
        this.purchaseCurrentSortColumn = event.column;
        this.purchaseCurrentSortOrder = event.order;
        this.setPageForPurchase(this.purchasePager.currentPage);
    }
    purchaseApplySort(){
        if(!this.purchaseCurrentSortColumn || !this.purchaseCurrentSortOrder) return;
        this.lz30PurchaseLicenseDetailList=this.lz30PurchaseLicenseDetailList.sort((a,b)=>
            {
                if(this.purchaseCurrentSortOrder==='asc'){
                    a[this.purchaseCurrentSortColumn]=a[this.purchaseCurrentSortColumn] || '';
                    return a[this.purchaseCurrentSortColumn].localeCompare(b[this.purchaseCurrentSortColumn])
                }
                else if (this.purchaseCurrentSortOrder==='desc'){
                    b[this.purchaseCurrentSortColumn]=b[this.purchaseCurrentSortColumn] || '';
                    return b[this.purchaseCurrentSortColumn].localeCompare(a[this.purchaseCurrentSortColumn])
                }
                else {
                    return 0;
                }
            }
        )
    }
    onDeviceSortChange(event){
        this.deviceCurrentSortColumn = event.column;
        this.deviceCurrentSortOrder = event.order;
        this.setPageForDemo(this.demoPager.currentPage);
    }
    deviceApplySort(){
        if(!this.deviceCurrentSortColumn || !this.deviceCurrentSortOrder) return;
        this.userDeviceDisplayDetail=this.userDeviceDisplayDetail.sort((a,b)=>
            {
                if(this.deviceCurrentSortOrder==='asc'){
                    a[this.deviceCurrentSortColumn]=a[this.deviceCurrentSortColumn] || '';
                    return a[this.deviceCurrentSortColumn].localeCompare(b[this.deviceCurrentSortColumn])
                }
                else if (this.deviceCurrentSortOrder==='desc'){
                    b[this.deviceCurrentSortColumn]=b[this.deviceCurrentSortColumn] || '';
                    return b[this.deviceCurrentSortColumn].localeCompare(a[this.deviceCurrentSortColumn])
                }
                else {
                    return 0;
                }
            }
        )
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/lz30/lz30.component.ts